import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ICollapsePanelProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ICollapsePanelProps>>
): IComponentSchema<ICollapsePanelProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.CollapsePanel,
    'x-component-props': {
      label: props?.['x-component-props']?.label || 'New Panel',
      defaultActive:
        props?.['x-component-props']?.defaultActive !== undefined
          ? props['x-component-props']!.defaultActive
          : true,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {},
  };
};
